<style>
  .modal-content {
    width: 1000px !important;
    max-width: 1200px !important;
  }
</style>

  <div class="modal-header">
    <h3 class="modal-title">Create Multiple Timecards</h3>
    <button type="button" class="btn-close" aria-hidden="true" (click)="cancel()"></button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-lg-5">
        <div class="row">
          <div class="col-lg-12">
            <textarea type="text" readonly
                      style="resize:none;overflow:auto;min-width:320px;width:320px;"
                      class="form-control"
                      value="{{displaySelectedDates}}"></textarea>
          </div>
          <div class="col-lg-12">
            <div class="form-group">
              <div class="form-group">
                <div class="input-group date multi-datetimepicker" style="width:100%;">
                  <nbc-multiselect-calendar [dateFormat]="'MMM-DD'"
                                            [selectedDates]="selectedDates"
                                            (selectedDatesChange)="datesValueChanged($event)"></nbc-multiselect-calendar>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-7 multiple-timecards">
        <div class="row">
          <div class="col-lg-4">
            <label>Event/Show</label>
            <div>
              <input class="form-control event-search"
                     type="text"
                     maxlength="100"
                     placeholder="Event/Show"
                     [(ngModel)]="timecard.eventShowName" />
            </div>
          </div>
          <div class="col-lg-4">
            <label>Network</label>
            <nbc-select [source]="networks"
                        [(model)]="timecard.network"
                        display="description"
                        value="id"
                        name="multi_tc_network"
                        placeHolderValue="-1"
                        placeHolderDisplay="Select"></nbc-select>
          </div>
          <div class="col-lg-4">
            <label>Work State</label>
            <nbc-select [source]="workStates"
                        [(model)]="timecard.stateContactWorked"
                        display="description"
                        value="id"
                        name="multi_tc_workStates"
                        placeHolderValue="-1"
                        placeHolderDisplay="Select"></nbc-select>

          </div>



        </div>
        <div class="row">
          <div class="col-lg-4">
            <label>Employee Type</label>
            <nbc-select [source]="employeeTypes"
                        [(model)]="timecard.employeeType"
                        display="description"
                        value="id"
                        name="bulkUpdate_employee"
                        placeHolderValue="-1"
                        placeHolderDisplay="Select"></nbc-select>
          </div>

          <div class="col-lg-4">
            <label>Sport</label>
            <nbc-select [source]="sports"
                        [(model)]="timecard.sport"
                        display="description"
                        value="id"
                        name="bulkUpdate_sport"
                        placeHolderValue="-1"
                        placeHolderDisplay="Select">
            </nbc-select>
          </div>



          <div class="col-lg-4">
            <label>Rate(Day)</label>
            <div class="input-group">
              <div class="input-group-text">$</div>
              <div class="pull-left w-75">

                <input class="form-control event-search" id="rate-{{timecard.id}}"
                       name="rate-{{timecard.id}}"
                       appInputRestriction="decimalOnly"
                       placeholder="---.--"
                       type="text"
                       maxlength="9"
                       decimals="5"
                       [(ngModel)]="timecard.customRate"
                       (blur)="customFormat(timecard.customRate)" />

              </div>
            </div>

          </div>

        </div>

        <div class="row">

          <div class="col-lg-4">
            <label>Company Code</label>
            <nbc-select [source]="companyCodes"
                        [(model)]="timecard.companyCode"
                        display="description"
                        value="description"
                        name="multi_tc_companycode"
                        placeHolderValue="-1"
                        placeHolderDisplay="Select"></nbc-select>
          </div>

          <div class="col-lg-4">
            <label>GL Account</label>
            <glaccount name="multi_tc_glAccount"
                       nbcClass="form-control"
                       placeHolder="Enter GL Account"
                       [(model)]="timecard.glAccount"
                       typeaheadOptionLimit="20">
            </glaccount>
          </div>
          <div class="col-lg-4">

            <label>Hours Worked</label>

            <input type="text"
                   title=""
                   style="width:50px;"
                   data-field="hoursWorked"
                   value=""
                   nbc-decimal
                   decimals="5"
                   name="hoursWorked"
                   [(ngModel)]="timecard.hoursWorked"
                   class="form-control hours-worked" />
          </div>


        </div>

        <div class="row">


          <div class="col-lg-6">
            <label> WBSE/COST Center</label>


            <div class="cost-center-selection" style="margin-top:10px;">
              <input type="radio"
                     class="cost-center-el"
                     value="wbse"
                     (click)="wbseorcc()"
                     [(ngModel)]="costCenterType"
                     name="costCenterType" /> <br />WBSE
              <br />
              <input type="radio"
                     class="cost-center-el"
                     value="cc"
                     (click)="wbseorcc()"
                     [(ngModel)]="costCenterType"
                     name="costCenterType" /><br /> CC

            </div>

            <div class="grid-itm cost-center d-flex">
              <div class="input-group">
                <div *ngIf="costCenterType=='wbse'"
                     class="cost-center-input" id="wbse">
                  <div id="wbse" class="required-msg hide">Required</div>
                  <div class="input-group">
                    <input type="text" class="form-control"
                           title=""
                           maxlength="100"
                           name="wbse"
                           [(ngModel)]="timecard.wbsecode" />
                    <span class="input-group-btn">
                      <button class="btn btn-primary btncls wbse-el" style="margin:0px!important;" (click)="openWBSEModal()">
                        <i class="fa fa-search"></i>
                      </button>
                    </span>
                  </div>
                </div>

                <div *ngIf="costCenterType!='wbse'" class="cost-center-input" id="costCenter">
                  <div id="costCenter" class="required-msg hide">Required</div>
                  <input type="text"
                         title=""
                         data-field="costCenter"
                         value=""
                         maxlength="100"
                         name="costCenter"
                         [(ngModel)]="timecard.costCenter"
                         class="form-control cost-center-input-el" />
                </div>
              </div>
            </div>


          </div>
          <div class="col-lg-6">
            <label>Day Type</label>
            <nbc-select [source]="daytypes"
                        [(model)]="timecard.daytype"
                        display="description"
                        value="id"
                        name="bulkUpdate_daytype"
                        placeHolderValue="-1"
                        placeHolderDisplay="Select">
            </nbc-select>
          </div>


        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary" style="float:right;" type="submit" [attr.disabled]="(selectedDates?.length==0) || null" (click)="createTimeSheet()">Create</button>
    <button class="btn btn-default" style="float:right;" type="button" (click)="cancel()">Cancel</button>
  </div>


